export enum CheckoutStatus {
  Default = 'DEFAULT',
  PaymentSucceeded = 'PAYMENT_SUCCEEDED',
  PaymentFailed = 'PAYMENT_FAILED',
  ACHSetupFailed = 'ACH_SETUP_FAILED',
  BookingNotAllowed = 'BOOKING_NOT_ALLOWED',
  UnknownError = 'UNKNOWN_ERROR'
}
